const paper = {
  variant: 'cards.primary',
  p: 4
}

export default paper